import PropTypes from 'prop-types'
import React, {useState} from "react"

import { Switch, BrowserRouter as Router, Route } from "react-router-dom"
import { connect } from "react-redux"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"

// Import scss
import "./assets/scss/theme.scss"

// import Auth Context
import {AuthContext} from '../src/Context/Auth'

//import private route component
import PrivateRoute from './routes/AuthRoutes/PrivateRoutes'

// import pages
import Login from './pages/Authentication/Login'
import Reset from './pages/Authentication/Reset'
import ResetPassword from './pages/Authentication/ResetPassword'
import LinkExpired from './pages/Authentication/LinkExpired'
import PasswordSucess from './pages/Authentication/PasswordSucess'
import EmailCheck from './pages/Authentication/EmailCheck'


// Campaigns
import Campaigns from '../src/pages/Campaigns/Campaigns'
import SelectMerchant from '../src/pages/Campaigns/SelectMerchant'
// public promotions codes
import PromotionCodes from "../src/pages/PublicPromoCode/PromotionCodes"
import CreateCode from "../src/pages/CreateCode/CreateCode"
import UpdateCode from "../src/pages/UpdateCode/UpdateCode"

// merchant screens
import MerchantDashboard from "../src/pages/MerchantDashboard/MerchantDashboard"
import MerchantCreateCode from "../src/pages/MerchantCreateCode/MerchantCreateCode"
import MerchantUpdateCode from "../src/pages/MerchantUpdateCode/MerchantUpdateCode"
import FRxHome from './pages/Carousel-Banners/FRxHome'
import AddCarouselBanner from './pages/Carousel-Banners/AddCarouselBanner'
import AddCarouselBannerNew from './pages/Carousel-Banners/AddCarouselBannerNew'
import EditCarouselBannerNew from './pages/Carousel-Banners/EditCarouselBannerNew'
import EditCarouselBanner from './pages/Carousel-Banners/EditCarouselBanner'
import Rewards from './pages/Carousel-Banners/Rewards'
import MakanMaster from './pages/Carousel-Banners/MakanMaster'
import FRxHomeSingleBanners from './pages/SingleBanners/FRxHomeSingleBanners'
import RewardsSingle from './pages/SingleBanners/RewardsSingle'
import AddSingleBanner from './pages/SingleBanners/AddSingleBanner'
import EditSingleBanner from './pages/SingleBanners/EditSingleBanner'
import EditCheckout from './pages/Shoutouts/EditCheckout'
import Minibanners from "./pages/Marketing-Banners/MiniBanners"
import SplashScreens from "./pages/Marketing-Banners/SplashScreens"
import AddSplashBanners from "./pages/Marketing-Banners/AddSplashBanners"
import AddMiniBanners from "./pages/Marketing-Banners/AddMiniBanners"
import Payments from "./pages/Payments/Payments"
import AddPaymentMethods from "./pages/Payments/AddPaymentMethods"
import PromotionCodesMerchant from './pages/PublicPromoCode/PromoCodesMerchant'
import Widgets from './pages/Widgets'
import AddWidget from './pages/Widgets/AddWidget'
import MPEstore from './pages/MarketplaceBanners/MPEstore'
import MPMakanMaster from './pages/MarketplaceBanners/MPMakanMaster'
import MPGrabFood from './pages/MarketplaceBanners/MPGrabFood'
import MPGrabPromo from './pages/MarketplaceBanners/MPGrabPromo'
import AddMarketPlaceBanner from './pages/MarketplaceBanners/AddMarketPlaceBanner'
import EditMarketPlaceBanner from './pages/MarketplaceBanners/EditMarketPlaceBanner'
import DeepLinkNavigation from '../src/pages/DeeplinkNavigation'
import AddDeepLinkNavigation from '../src/pages/DeeplinkNavigation/AddDeeplinkNavigation'
import Ribbon from '../src/pages/Ribbon'
import AddRibbon from './pages/Ribbon/AddRibbon'
import EditRibbon from './pages/Ribbon/EditRibbon'
import Services from './pages/Services'
import AddService from './pages/Services/AddService'
import Settings from './pages/Settings'
import AddSetting from './pages/Settings/AddSetting'
import MenuLabels from './pages/MenuLabels'
import AddMenuLabel from './pages/MenuLabels/AddMenuLabel'
import SideDrawer from './pages/SideDrawer'
import AddSideDrawer from './pages/SideDrawer/AddSideDrawer'
import AppVersion from './pages/AppVersion'
import AddAppVersion from './pages/AppVersion/AddAppVersion'
import AddWelcomeScreen from './pages/WelcomeScreens/AddWelcomeScreen'
import WelcomeScreens from './pages/WelcomeScreens'
import QRCodeNote from './pages/Payments/QRCodeNote'
import AddQRCodeNote from './pages/Payments/AddQRCodeNote'
import EditQRCodeNote from './pages/Payments/EditQRCodeNote'
import PartnerReward from './pages/PartnerReward'
import AddPartnerReward from './pages/PartnerReward/AddPartnerReward'
import EditPartnerReward from './pages/PartnerReward/EditPartnerReward'
import AddGiftCard from './pages/GiftCards/AddGiftCard'
import EditGiftCard from './pages/GiftCards/EditGiftCard'
import GiftCards from './pages/GiftCards'
import HomepageCards from './pages/HomepageCards'
import AddHomepageCard from './pages/HomepageCards/AddHomepageCard'
import EditHomepageCard from './pages/HomepageCards/EditHomepageCard'
import ReferFriendCards from './pages/ReferFriendCards'
import AddReferFriendCard from './pages/ReferFriendCards/AddReferFriendCard'
import EditReferFriendCard from './pages/ReferFriendCards/EditReferFriendCard'
import ReferFriendWidgets from './pages/ReferFriendWidgets'
import AddReferFriendWidget from './pages/ReferFriendWidgets/AddReferFriendWidget'
import EditReferFriendWidget from './pages/ReferFriendWidgets/EditReferFriendWidget'
import ReferLink from './pages/ReferLink'
import PaymentSlider from './pages/PaymentSlider'
import AddPaymentSlider from './pages/PaymentSlider/AddPaymentSlider'
import UserManagement from './pages/UserManagement'
import AddUser  from './pages/UserManagement/AddUser'
import EditUser from './pages/UserManagement/EditUser'
import Permissions from './pages/Permissions'
import AddPermission from './pages/Permissions/AddPermission'
import Roles from './pages/Roles'
import AddRole from './pages/Roles/addRole'
import AddCampaignDgc from './pages/CampiagnDgc/AddCampaignDgc'
import CampaignDgc from './pages/CampiagnDgc'
import EditCampaignDgc from './pages/CampiagnDgc/EditCampaignDgc'
import AddGrabFoodBanner from './pages/MarketplaceBanners/AddGrabFoodBanner'
import EditGrabFoodBanner from './pages/MarketplaceBanners/EditGrabFoodBanner'
import OtpLogin from './pages/Authentication/OtpLogin'
import useAutoLogout from './common/useAutoLogout'
import PaymentExit from './pages/PaymentExit'
import AddPaymentExit from './pages/PaymentExit/AddPaymentExit'
import GrabFood from './pages/PaymentExit/GrabFood'
import GrabMart from './pages/PaymentExit/GrabMart'
import GrabPay from './pages/PaymentExit/GrabPay'
import CreditCard from './pages/PaymentExit/CreditCard'
import OcbcDigital from './pages/PaymentExit/OcbcDigital'
import PayLater from './pages/PaymentExit/PayLater'
import LifeSG from './pages/PaymentExit/LifeSG'
import PayNow from './pages/PaymentExit/PayNow'
import CarparkModal from './pages/CarparkModal'
import AddCarparkModal from './pages/CarparkModal/AddCarparkModal'
import AddGrabPromo from './pages/MarketplaceBanners/AddGrabPromo'
import EditGrabPromo from './pages/MarketplaceBanners/EditGrabPromo'
import FAQs from './pages/FAQs'
import ExportAEMStoresPage from './pages/ExportAEMStores'
import ToolsPage from './pages/Tools'

const App = props => {

  const existingTokens = localStorage.getItem("AuthenticationToken");
  const [authTokens, setAuthTokens] = useState(existingTokens);

  useAutoLogout()        //for Automatically logout user after 15 minute

  const setTokens = (data) => {
    console.log("Set Auth TOken in App.js", data)
    localStorage.setItem("AuthenticationToken", data);
    setAuthTokens(data); 
  }

  function getLayout() {
    let layoutCls = VerticalLayout

    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout
        break
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
   }  

  const Layout = getLayout()
  return (
    <React.Fragment>
      <AuthContext.Provider value={{ authTokens, setAuthTokens: setTokens }}>
          <Router>
            <Switch>
              {/* <-------------Manage Login and Reset Password--------------> */}
            <Route exact path="/" component={Login} />
            <Route exact path="/otp-login" component={OtpLogin} />
            <Route exact path="/reset-password" component={Reset} />
            <Route exact path="/password/:code" component={ResetPassword} />
            <Route exact path="/link-expired" component={LinkExpired} />
            <Route exact path="/success-password" component={PasswordSucess} />
            <Route exact path="/email-check" component={EmailCheck} />

            {/* <-------------eStore App Section--------------> */}
            {/* <PrivateRoute exact path="/estore-home/carousel-banners" component={EStore} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/add-carousel-banner" component={AddEstoreBanner} layout={Layout} permission={"appsections"} />
            <PrivateRoute exact path="/estore-home/edit-carousel-banner" component={EditEstoreBanner} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/banner-feature" component={BannerFeature} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/popups" component={Popups} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/add-popups" component={AddPopups} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/flexi-features" component={FlexiFeature} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/add-flexi-features" component={AddFlexiFeatures} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/add-estore-home" component={AddEstoreHomeBanner} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/edit-estore-home" component={EditEstoreHomeBanner} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/trending" component={Trending} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/editor-picks" component={EditorsPick} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/menu-banners" component={MenuBanners} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/menu-banners/add-menu-banners" component={AddMenuBanners} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/add-featured-brands" component={AddFeaturedBrands} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/single-banner" component={EstoreSingleBanners} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/single-banners/add-single-banner" component={EstoreSingleBannerAdd}  layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/single-banners/edit-single-banner" component={EstoreSingleBannerEdit} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/swap-section" component={SwapSection} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/top-ribbons" component={TopRibbons} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/add-top-ribbons" component={AddTopRibbon} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/left-ribbons" component={LeftRibbon} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/right-ribbons" component={RightRibbon} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/checkout" component={Checkout} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/category-blurbs" component={CategoryBlurbs} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/shoutouts/add-category-blurbs" component={AddCategoryBlurb} layout={Layout} permission={"appsections"}/>
            <PrivateRoute exact path="/estore-home/featured-brands" component={FeaturedBrands} layout={Layout} permission={"appsections"}/> */}
            
            {/* <-------------Carousel--------------> */}
            <PrivateRoute exact path="/carousel-banners/frx-home" component={FRxHome} layout={Layout} permission={"carousel"}/>
            <PrivateRoute exact path="/carousel-banners/rewards" component={Rewards} layout={Layout} permission={"carousel"}/>
            <PrivateRoute exact path="/carousel-banners/makan-master" component={MakanMaster} layout={Layout} permission={"carousel"}/>
            <PrivateRoute exact path="/carousel-banners/add-carousel-banner" component={AddCarouselBanner} layout={Layout} permission={"carousel"}/>
            <PrivateRoute exact path="/carousel-banners/add-carousel-banner-new" component={AddCarouselBannerNew} layout={Layout} permission={"carousel"}/>
            <PrivateRoute exact path="/carousel-banners/edit-carousel-banner-new" component={EditCarouselBannerNew} layout={Layout} permission={"carousel"}/>
            <PrivateRoute exact path="/carousel-banners/edit-carousel-banner" component={EditCarouselBanner} layout={Layout} permission={"carousel"}/>
            {/* <-------------Single--------------> */}
            <PrivateRoute exact path="/single-banners/frx-home-single-banners" component={FRxHomeSingleBanners} layout={Layout} permission={"tiles_banners"}/>
            <PrivateRoute exact path="/single-banners/rewards-single" component={RewardsSingle} layout={Layout} permission={"tiles_banners"} />
            <PrivateRoute exact path="/single-banners/add-single-banners" component={AddSingleBanner} layout={Layout} permission={"tiles_banners"}/>
            <PrivateRoute exact path="/single-banners/edit-single-banners" component={EditSingleBanner} layout={Layout} permission={"tiles_banners"}/>
            <PrivateRoute exact path="/shoutouts/edit-checkout-text" component={EditCheckout} layout={Layout}/>
            {/* <-------------Splash and Mini Banners--------------> */}
            <PrivateRoute exact path="/marketing-banners/mini-banners" component={Minibanners} layout={Layout} permission={"banners"}/>
            <PrivateRoute exact path="/marketing-banners/splash-screens" component={SplashScreens} layout={Layout} permission={"banners"}/>
            <PrivateRoute exact path="/marketing-banners/add-mini-banner" component={AddMiniBanners} layout={Layout} permission={"banners"}/>
            <PrivateRoute exact path="/marketing-banners/add-splash-banner" component={AddSplashBanners} layout={Layout} permission={"banners"}/>
            {/* <-------------Market Place Banners--------------> */}
            <PrivateRoute exact path="/market-place/estore" component={MPEstore} layout={Layout} permission={"marketplacebanners"} />
            <PrivateRoute exact path="/market-place/makan-master" component={MPMakanMaster} layout={Layout} permission={"marketplacebanners"}/>
            <PrivateRoute exact path="/market-place/grab-food" component={MPGrabFood} layout={Layout} permission={"marketplacebanners"}/>
            <PrivateRoute exact path="/market-place/grab-promo" component={MPGrabPromo} layout={Layout} permission={"marketplacebanners"}/>
            <PrivateRoute exact path="/add-market-place-banner" component={AddMarketPlaceBanner} layout={Layout} permission={"marketplacebanners"}/>
            <PrivateRoute exact path="/edit-market-place-banner" component={EditMarketPlaceBanner} layout={Layout} permission={"marketplacebanners"}/>
            <PrivateRoute exact path="/add-grab-food-banner" component={AddGrabFoodBanner} layout={Layout} permission={"marketplacebanners"}/>
            <PrivateRoute exact path="/edit-grab-food-banner" component={EditGrabFoodBanner} layout={Layout} permission={"marketplacebanners"}/>
            <PrivateRoute exact path="/add-grab-promo" component={AddGrabPromo} layout={Layout} permission={"marketplacebanners"}/>
            <PrivateRoute exact path="/edit-grab-promo" component={EditGrabPromo} layout={Layout} permission={"marketplacebanners"}/>


            {/* <-------------Ribbons--------------> */}
            <PrivateRoute exact path="/ribbons" component={Ribbon} layout={Layout} permission={"ribbons"}/>
            <PrivateRoute exact path="/add-ribbon" component={AddRibbon} layout={Layout} permission={"ribbons"}/>
            <PrivateRoute exact path="/edit-ribbon" component={EditRibbon} layout={Layout} permission={"ribbons"}/>

            {/* <-------------More Section--------------> */}
            <PrivateRoute exact path="/gift-cards" component={GiftCards} layout={Layout} permission={"moreSection"} />
            <PrivateRoute exact path="/add-gift-card" component={AddGiftCard} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/edit-gift-card" component={EditGiftCard} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/homepage-cards" component={HomepageCards} layout={Layout} permission={"moreSection"} />
            <PrivateRoute exact path="/add-homepage-card" component={AddHomepageCard} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/edit-homepage-card" component={EditHomepageCard} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/refer-friend-cards" component={ReferFriendCards} layout={Layout} permission={"referfriend"} />
            <PrivateRoute exact path="/add-refer-friend-card" component={AddReferFriendCard} layout={Layout} permission={"referfriend"}/>
            <PrivateRoute exact path="/edit-refer-friend-card" component={EditReferFriendCard} layout={Layout} permission={"referfriend"}/>
            <PrivateRoute exact path="/refer-friend-widgets" component={ReferFriendWidgets} layout={Layout} permission={"referfriend"} />
            <PrivateRoute exact path="/add-refer-friend-widget" component={AddReferFriendWidget} layout={Layout} permission={"referfriend"}/>
            <PrivateRoute exact path="/edit-refer-friend-widget" component={EditReferFriendWidget} layout={Layout} permission={"referfriend"}/>
            <PrivateRoute exact path="/refer-link" component={ReferLink} layout={Layout} permission={"referfriend"} />
            <PrivateRoute exact path="/partner-reward" component={PartnerReward} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/add-partner-reward" component={AddPartnerReward} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/edit-partner-reward" component={EditPartnerReward} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/widgets" component={Widgets} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/add-widget" component={AddWidget} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/add-qr-code-note" component={AddQRCodeNote} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/qr-code-note" component={QRCodeNote} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/edit-qr-code-note" component={EditQRCodeNote} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/payment-sliders" component={PaymentSlider} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/add-payment-slider" component={AddPaymentSlider} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/paymentexit" component={PaymentExit} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/add-modal-message" component={AddPaymentExit} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/grabfood" component={GrabFood} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/grabmart" component={GrabMart} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/grabpay" component={GrabPay} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/creditcard" component={CreditCard} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/ocbcdigital" component={OcbcDigital} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/paylater" component={PayLater} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/lifesg" component={LifeSG} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/paynowqr" component={PayNow} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/rewardsmodal" component={CarparkModal} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/add-rewards-modal" component={AddCarparkModal} layout={Layout} permission={"moreSection"}/>
            <PrivateRoute exact path="/edit-rewards-modal" component={AddCarparkModal} layout={Layout} permission={"moreSection"}/>
             {/* <-------------others Section--------------> */}
             <PrivateRoute exact path="/faqs" component={FAQs} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/export-aem-stores" component={ExportAEMStoresPage} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/tools" component={ToolsPage} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/payments" component={Payments} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/payments/add-payment-method" component={AddPaymentMethods} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/deeplink-navigation" component={DeepLinkNavigation} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/add-deeplink-navigation" component={AddDeepLinkNavigation} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/services" component={Services} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/add-service" component={AddService} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/settings" component={Settings} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/add-setting" component={AddSetting} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/menu_labels" component={MenuLabels} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/add-menu-label" component={AddMenuLabel} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/sidedrawer" component={SideDrawer} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/add-side-drawer" component={AddSideDrawer} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/app-version" component={AppVersion} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/add-app-version" component={AddAppVersion} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/add-screen" component={AddWelcomeScreen} layout={Layout} permission={"othersSection"}/>
            <PrivateRoute exact path="/screens" component={WelcomeScreens} layout={Layout} permission={"othersSection"}/>

            {/* <-------------Permissions, Roles and User Management--------------> */}
            <PrivateRoute exact path="/manage-users" component={UserManagement} layout={Layout} permission={"usersmanagement"}/>
            <PrivateRoute exact path="/add-user" component={AddUser} layout={Layout} permission={"usersmanagement"}/>
            <PrivateRoute exact path="/edit-user" component={EditUser} layout={Layout} permission={"usersmanagement"}/>
            <PrivateRoute exact path="/permissions" component={Permissions} layout={Layout} permission={"permissions"}/>
            <PrivateRoute exact path="/add-permission" component={AddPermission} layout={Layout} permission={"permissions"}/>
            <PrivateRoute exact path="/roles" component={Roles} layout={Layout} permission={"rolesmanagement"}/>
            <PrivateRoute exact path="/add-role" component={AddRole} layout={Layout} permission={"rolesmanagement"}/>
            
            {/* <-------------Merchant Dashborad and Campaigns--------------> */}
            <PrivateRoute exact path="/select-merchant" component={SelectMerchant} layout={Layout} permission={"campaigns"}/>
            <PrivateRoute exact path="/campaigns" component={Campaigns} layout={Layout} permission={"campaigns"}/>
            <PrivateRoute exact path="/promo-codes/:campaignID" component={PromotionCodes} layout={Layout} permission={"campaigns"}/>
            <PrivateRoute exact path="/promo-codes-merchant/:campaignID" component={PromotionCodesMerchant} layout={Layout} permission={"campaigns"}/>
            <PrivateRoute exact path="/create-campaign" component={CreateCode} layout={Layout} permission={"campaigns"}/>
            <PrivateRoute exact path="/update-campaign/:campaignID" component={UpdateCode} layout={Layout} permission={"campaigns"}/>
            <PrivateRoute exact path="/merchant-dashboard" component={MerchantDashboard} layout={Layout} permission={"campaigns"}/>
            <PrivateRoute exact path="/merchant-create-code" component={MerchantCreateCode} layout={Layout} permission={"campaigns"}/>
            <PrivateRoute exact path="/merchant-update-code" component={MerchantUpdateCode} layout={Layout} permission={"campaigns"}/>

              {/* <-------------Campaign DGC--------------> */}
            <PrivateRoute exact path="/campaign-dgc" component={CampaignDgc} layout={Layout} permission={"campaigns"}/>
            <PrivateRoute exact path="/add-campaign-dgc" component={AddCampaignDgc} layout={Layout} permission={"campaigns"}/>
            <PrivateRoute exact path="/edit-campaign-dgc" component={EditCampaignDgc} layout={Layout} permission={"campaigns"}/>
            </Switch>
          </Router>
      </AuthContext.Provider>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)